//  @flow

import * as React from 'react';

import './style.css';

type LazyProps = {
  children: React.Node
};

type LazyState = {
  isVisible: boolean
};

class LazyComponent extends React.PureComponent<LazyProps, LazyState> {
  ref: any;

  constructor(props: LazyProps) {
    super(props);
    this.state = {
      isVisible: false
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    const options = {
      rootMargin: '0px',
      threshold: 0.3
    };
    const observer = new IntersectionObserver(entries => {
      if (entries && entries.length > 0 && entries[0].isIntersecting) {
        this.setState({
          isVisible: true
        });
        observer.unobserve(this.ref);
      }
    }, options);
    observer.observe(this.ref);
  }

  render = () => {
    const { isVisible } = this.state;
    const { children } = this.props;
    return (
      <div
        className="lazy-container"
        ref={r => {
          this.ref = r;
        }}
        style={{ width: 'auto', height: isVisible ? 'auto' : '300px' }}>
        {isVisible ? children : <div className="fallback" />}
      </div>
    );
  };
}

export default LazyComponent;



// WEBPACK FOOTER //
// ./src/Components/LazyComponent/index.js